module.exports = {
	"api": {
		"baseUrl": "https://easygestor-api-homolog.fly.dev",
		"timeout": 8000,
		"retries": 5
	},
	"site": {
		"title": "EasyGestor",
		"description": "Sistema de Gestão Empresarial",
		"keywords": "gestão, empresarial, sistema, easygestor",
		"favicon": "/favicon.ico"
	},
	"features": {
		"debugMode": false,
		"mockData": false,
		"analytics": true,
		"hideGoogleRecaptcha": true
	},
	"theme": {
		"font": {
			"family": "Titillium Web",
			"url": "https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap"
		},
		"colors": {
			"primary": "#0073a7",
			"primaryVariant": "#00b0ff",
			"secondary": "#00b0ff",
			"secondaryVariant": "#0f8cda",
			"light": "#ced6e0",
			"red": "#ef314a",
			"yellow": "#fcfc30",
			"darkBlue": "#056baa",
			"lightBlue": "#12a3ff",
			"lightBlue2": "#e6f4ff",
			"lightCyan": "#bdced5",
			"lightDark": "#889ba2",
			"dark": "#040f1f",
			"danger": "#e74c3c",
			"lightDanger": "#e74c3c",
			"info": "#3498db",
			"infoVariant": "#2980b9",
			"success": "#00d069",
			"successVariant": "#009149",
			"warn": "#ffdd59",
			"white": "#ffffff"
		},
		"text": {
			"letterSpacing": ".7px"
		},
		"button": {
			"borderRadius": "3px",
			"padding": "8px 20px;",
			"background": "#0073a7",
			"color": "#fff",
			"hoverBackground": "#044873",
			"hoverColor": "#ffffff",
			"letterSpacing": "0px"
		},
		"navbar": {
			"width": "240px",
			"backgroundColor": "#2f4050",
			"hoverColor": "#12a3ff",
			"header": {
				"height": "60px",
				"backgroundColor": "#056baa"
			},
			"hover": {
				"backgroundColor": "#12a3ff",
				"textColor": "#fff"
			},
			"submenu": {
				"backgroundColor": "#056baa"
			},
			"active": {
				"backgroundColor": "#12a3ff",
				"textColor": "#fff"
			}
		}
	},
	"views": {
		"excludevViews": [
			""
		]
	},
	"menu": {
		"excludePaths": [
			""
		]
	},
	"login": {
		"maxAttempts": 5,
		"lockoutDuration": 15,
		"method": "",
		"logoutRedirect": "/",
		"brands": [
			"https://content.easygestor.com/wp-content/uploads/2025/09/logo_03.png",
			"https://content.easygestor.com/easygestor/logo_bb.png"
		],
		"redirect": "/"
	},
	"version": "1.0.0"
};


//////////////////
// WEBPACK FOOTER
// ./config/envs/easygestor/homolog.json
// module id = 617
// module chunks = 0